import "./StationInfo.scss";

import { DateTime } from "luxon";
import React from "react";

const units = ["year", "month", "week", "day", "hour", "minute", "second"];

export const formatDuration = (d) => {
  for (const unit of units) {
    const value = Math.floor(d.as(unit));
    if (value > 0) return { unit, value };
  }

  return { unit: "second", value: 0 };
};

export const formatDurationAgo = (d) => {
  const { unit, value } = formatDuration(d);

  if (value === 0) return "just now";
  if (value === 1) return `${value} ${unit} ago`;
  if (value > 1) return `${value} ${unit}s ago`;
};

const StationInfo = ({ channel }) => {
  let reporting = channel?.source?.reports?.join(", ");
  let activeDuration;
  try {
    activeDuration =
      channel.source.first_active &&
      formatDurationAgo(
        DateTime.utc().diff(DateTime.fromISO(channel.source.first_active))
      );
  } catch (err) {}

  return (
    <div className="station-info-panel">
      <img src={channel.source?.image} alt="" />
      <div className="station-info">
        <h3>Station Information</h3>
        <table>
          <tbody>
            <tr>
              <td>Provided by:</td>
              <td>
                <a
                  href={channel.source.provided_by_link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {channel.source.provided_by}
                </a>
              </td>
            </tr>
            {channel.source.model && (
              <tr>
                <td>Model:</td>
                <td>
                  <a
                    href={channel.source.model.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {channel.source.model.name}
                  </a>
                </td>
              </tr>
            )}
            {activeDuration && (
              <tr>
                <td>First Active:</td>
                <td>{activeDuration}</td>
              </tr>
            )}
            {reporting && (
              <tr>
                <td>Reporting:</td>
                <td>{reporting}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default StationInfo;
